import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1c8abf88"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "card"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "card__inner"
};
const _hoisted_4 = {
  class: "card__box"
};
const _hoisted_5 = {
  class: "card__title"
};
const _hoisted_6 = {
  key: 0,
  class: "card__list"
};
const _hoisted_7 = {
  key: 1,
  class: "loader-box"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "loader"
}, null, -1));
const _hoisted_9 = [_hoisted_8];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Card = _resolveComponent("Card");
  const _directive_auto_animate = _resolveDirective("auto-animate");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h2", _hoisted_5, _toDisplayString($props.cardListName), 1), _createElementVNode("button", {
    class: "card__btn",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('loadMoreItems'))
  }, "Смотреть все")]), $props.items.length > 0 ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, item => {
    return _openBlock(), _createBlock(_component_Card, {
      key: item.id,
      id: item.id,
      title: item.title,
      weight: item.weight,
      volume: item.volume,
      composition: item.composition,
      price: item.price,
      imgUrl: item.imgUrl,
      isHit: item.isHit,
      isNew: item.isNew,
      filter_1: item.filter_1,
      filter_2: item.filter_2,
      filter_3: item.filter_3,
      "is-favorite": item.isFavorite,
      "is-added": item.isAdded,
      category: item.category,
      "on-click-favorite": () => _ctx.$emit('addToFavorite', item),
      "on-click-add": () => _ctx.$emit('addToCart', item)
    }, null, 8, ["id", "title", "weight", "volume", "composition", "price", "imgUrl", "isHit", "isNew", "filter_1", "filter_2", "filter_3", "is-favorite", "is-added", "category", "on-click-favorite", "on-click-add"]);
  }), 128))])), [[_directive_auto_animate]]) : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))])])]);
}